import Vue from 'vue'
import Router from 'vue-router'
// import systemRoutes from '../view/system/router'
// import travelRoutes from '../view/travel/router'
// import trainRoutes from '../view/train/router'
// import viewRoutes from '../view/router'
// import hotelRoutes from '../view/hotel/router'






import ViewsRoutes from '../views/router'
import MallRoutes from '../views/mall/router'
import SystemRoutes from '../views/system/router'

import OrderRoutes from '../views/order/router'

import TradeRoutes from '../views/trade/router'


Vue.use(Router);
var routeCache = {};

function fnMergeRoute(route) {
  if (route.name == undefined || route.name == '') {
    routes.push(route);
    return;
  }
  var cache = routeCache[route.name];
  if (!cache) {
    cache = route;
    routeCache[route.name] = route;
    routes.push(route);
    return;
  }
  cache.children = _.union(cache.children, route.children);
}

var routes = [];
// $utils.each(travelRoutes, fnMergeRoute);
// $utils.each(systemRoutes, fnMergeRoute);
// $utils.each(trainRoutes, fnMergeRoute);
// $utils.each(viewRoutes, fnMergeRoute);
// $utils.each(hotelRoutes, fnMergeRoute);











$utils.each(ViewsRoutes, fnMergeRoute);
$utils.each(MallRoutes, fnMergeRoute);
$utils.each(SystemRoutes, fnMergeRoute);

$utils.each(OrderRoutes, fnMergeRoute);
$utils.each(TradeRoutes, fnMergeRoute);



export default new Router({
  mode: 'history',
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    var historys = $app.historys;
    var lastHistory = historys[historys.length - 1];
    if (to.path == lastHistory.path) {
      var $page = $(".page-content");
      if ($page.length > 0) {
        $page.scrollTop(lastHistory.scrollTop);
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js